import React, { useEffect, useState } from 'react'
import { injectIntl } from "react-intl";
import { withStyles } from '@material-ui/core/styles';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import '../style.scss';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useDispatch } from 'react-redux';
import { getPatientLabtestsListRequest } from '../../../store/appointments/actions';
import { useSelector } from 'react-redux';
import * as myImages from '../../../utils/images';
import AttachmentIcon from '@material-ui/icons/Attachment';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import moment from 'moment';
import { serialize } from "object-to-formdata";
import { getPaymentMethodsRequest, uploadPaymentImageRequest } from '../../../store/payments/actions';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { getAgenciesListRequest, getCitiesRequest } from '../../../store/usersLabs/actions';
import { samplingReservationRequest, setSampleReserved, samplingForceDepositedRequest, updateSamplingReservationRequest } from '../../../store/patients/actions';
import ErrorIcon from '@material-ui/icons/Error';
import WorkingHours from './WorkingHours';
import { changeShipmentsStatusRequest, getShippingLocationsRequest } from '../../../store/labTests/actions';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
// import { calendar } from '../../../utils/images';

const StyledAccordion = withStyles({
  root: {
    width: '100%',
    border: '1px solid #ccc',
    // boxShadow: 'rgba(0, 0, 0, 0.02) 0px 3px 5px',
    borderRadius: '0px',
    margin: '0',
    background: '#fff',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: '0',
    },
  },
  expanded: {},
})(Accordion);


function PatientLabtests({ intl: { messages }, patientId, patientCityId }) {
    const dispatch = useDispatch();
    const { patientLabtestsList } = useSelector((state) => state.appointments);
    const { paymentMethods, successUpload } = useSelector((state) => state.payments);
    const { cities, agenciesList } = useSelector((state) => state.usersLabs);
    const { shippingLocations } = useSelector((state) => state.labTests);
    const { sampleReserved } = useSelector((state) => state.patients);
    const [selectedAgency, setSelectedAgency] = useState(null);
    const [paymentMethodsList, setPaymentMethodsList] = useState([]);
    const [formData, setFormData] = useState([]);
    const [stageView, setStageView] = useState(null);
    const [workingHoursModal, setWorkingHoursModal] = useState(false);
    //const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [isNewLocation, setIsNewLocation] = useState(null);
    const [uploadedImage, setUploadedImage] = useState({
      file: "",
      fileName: "",
      fileSize: "",
      fileType: "",
    });

    const shippingCompanies = [
      {id: 1 , name: messages.labTests.form.company1},
      {id: 2 , name: messages.labTests.form.company2},
      {id: 3 , name: messages.labTests.form.company3},
    ];
  
    useEffect(() => {
      dispatch(getCitiesRequest())
      dispatch(getAgenciesListRequest())
      dispatch(getPaymentMethodsRequest());
      dispatch(getPatientLabtestsListRequest(patientId));
      dispatch(getShippingLocationsRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (patientLabtestsList && formData.length === 0) {
            patientLabtestsList?.map(lab => setFormData(prevState => [
              ...prevState,
              {
                id: lab.id,
                payment_method: lab.payment?.payment_method || null,
                bank_transfer_image: lab.payment?.paymentable?.url ? `${process.env.REACT_APP_BASE_URL}${lab.payment?.paymentable?.url}` : uploadedImage?.file ? uploadedImage.file : null,
                transfer_image: lab.payment?.paymentable?.url ? `${process.env.REACT_APP_BASE_URL}${lab.payment?.paymentable?.url}` : uploadedImage?.file ? uploadedImage.file : null,
                sampling_status: lab.samplingReservation ? 2 : (!lab.samplingReservation && lab.status > 6) ? 3 : lab.samplingReservation?.status ? lab.samplingReservation?.status : 1,
                sampling_date: lab.samplingReservation?.date ? moment(lab.samplingReservation?.date).format("YYYY-MM-DD") : null,
                sampling_time: lab.samplingReservation?.date ? moment(lab.samplingReservation?.date).format("HH:mm") : null,
                city_id: lab.samplingReservation?.city_id || 0,
                agency_id: lab.samplingReservation?.agency_id || 0,
                agency_name: lab.samplingReservation?.agency_name || null,
                agenciesList: lab.samplingReservation?.city_id ? agenciesList?.filter(agency => agency.city_id === lab.samplingReservation?.city_id) : [],
                offline_payment: lab.offline_payment || 0,
                new_offline_payment: null,
                notes: lab.samplingReservation?.notes || null,
                paymentable: lab.payment?.paymentable || null,
                shipments: lab.shipments || [{
                  id: null,
                  pickup_location_id: 0,
                  delivery_location_id: 0,
                  pickup_location: '',
                  delivery_location: '',
                  shipping_company: 0,
                  status: 0,
                  notes: '',
                }],
              }
            ]));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patientLabtestsList]);

    useEffect(() => {
      if (patientCityId && agenciesList?.length > 0) {
        setFormData(prevState => prevState.map(lab => {
          if(lab.city_id === 0) {
            return {
              ...lab,
              city_id: patientCityId,
              agenciesList: agenciesList?.filter(agency => agency.city_id === patientCityId),
            }
          } else {
            return {
              ...lab,
              agenciesList: agenciesList?.filter(agency => agency.city_id === lab.city_id),
            }
          }
        }));
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    } , [patientCityId, agenciesList]);

    useEffect(() => {
      if (paymentMethods) {
        setPaymentMethodsList(paymentMethods);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentMethods])

    const [imageErrors, setImageErrors] = useState({
        typeErr: false,
        sizeErr: false,
    });
    const fileSize = 1;

    const onFileChange = (event, labtestIndex) => {
        setImageErrors({ typeErr: false, sizeErr: false });
        setUploadedImage({
          file: event.target.files[0],
          fileName: event.target.files[0]?.name,
          fileSize: event.target.files[0]?.size, //size in bytes
          fileType: event.target.files[0]?.type,
        });
        checkSelectedFileValidation(event, labtestIndex);
      };
      const checkSelectedFileValidation = (event, labtestIndex) => {
        if (event.target.files[0]) {
          setImageErrors({
            sizeErr: event.target.files[0].size / 2048 / 2048 > fileSize,
            msg:
              event.target.files[0].size / 2048 / 2048 > fileSize
                ? messages.errors.imageSizeErr2
                : messages.errors.imageTypeErr3,
          });
          if (event.target.files[0].size / 2048 / 2048 < fileSize) {
            viewImageHandler(event.target.files[0], labtestIndex);
          }
        }
      };
    
      const cancelChangeImage = (labtestIndex) => {
        setImageErrors({ typeErr: false, sizeErr: false });
        setUploadedImage({
          file: "",
          fileName: "",
          fileSize: "",
          fileType: "",
        });
        setFormData(
          formData.map((item, index) => {
            if (index === labtestIndex) {
              return { ...item, bank_transfer_image: null };
            }
            return item;
          }
          )
        );
      };
    
      const viewImageHandler = (file, labtestIndex) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
         // setSelectedImage(e.target.result);
         setFormData(
          formData.map((item, index) => {
            if (index === labtestIndex) {
              return { ...item, bank_transfer_image: e.target.result, transfer_image: file };
            }
            return item;
          }
          )
        );
        };
      };
    
      //Payment
      const handleUpdateImg = (labtestID, PaymentID) => {
          const selectedLabtest = formData.find(item => item.id === labtestID);
          if (selectedLabtest.transfer_image) {
            let myForm = {}
            if (selectedLabtest?.payment_method === 3) {
              if (selectedLabtest?.new_offline_payment) {
                myForm = {
                  payment_method: selectedLabtest?.payment_method,
                  offline_payment: {
                    image: selectedLabtest?.transfer_image,
                    method_name: selectedLabtest?.new_offline_payment ? selectedLabtest?.new_offline_payment : null,
                  }
                }
              } else {
                myForm = {
                  payment_method: selectedLabtest?.payment_method,
                  offline_payment: {
                    image: selectedLabtest?.transfer_image,
                    offline_payment_method_id: selectedLabtest?.offline_payment,
                  }
                }
              }
            } else if (selectedLabtest?.payment_method === 2) {
              setImageErrors({ sizeErr: false, msg: 'Online Payment Selected' });
            } else if (selectedLabtest?.payment_method === 1) {
              myForm = {
                payment_method: selectedLabtest?.payment_method,
                transfer_image: selectedLabtest?.transfer_image,
              }
            } else {
              setImageErrors({ sizeErr: false, msg: 'Please Select Payment Method' });
            }
            const payload = serialize(myForm);
            dispatch(uploadPaymentImageRequest(payload, PaymentID));
            setTimeout(() => {
                dispatch(getPatientLabtestsListRequest(patientId));
            }, 1000);
            setImageErrors({ sizeErr: false, msg: '' });
          } else {
            setImageErrors({ sizeErr: true, msg: messages.errors.noImage });
          }
      }
    
    useEffect(() => {
      if (successUpload) {
        setFormData((prevState) => prevState.map(item => {
              return { ...item,
                payment_method: null,
                bank_transfer_image: null,
                transfer_image: null,
                offline_payment: 0,
                new_offline_payment: null,
              };
          }
          )
        );
        setUploadedImage({
          file: "",
          fileName: "",
          fileSize: "",
          fileType: "",
        });
        setImageErrors({ sizeErr: false, msg: '' });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    } , [successUpload]);

    console.log(formData);

    if (patientLabtestsList?.length > 0) {
      return (
        <div className="patient-labtests-container">
            {
              patientLabtestsList?.map((labtest, index) => (
                <>
                  <StyledAccordion defaultExpanded key={index}>
                      <AccordionSummary
                          aria-controls="panel3c-content"
                          id="panel3c-header">
                          <div className='myaccordion_header'>
                            <h3>{labtest.lab_test_name} <KeyboardArrowDownIcon /></h3>
                            {
                              labtest.request_stage === 4 ? (
                                <div className='myaccordion_header_left'>
                                  <span>{messages.patients.form.canceled}</span>
                                </div>
                              ) : (
                                <>
                                  {
                                    labtest.status === 4 || labtest.status === 6 ? (
                                      <div className='myaccordion_header_left'>
                                        <span style={{ color: "#444" }}>{messages.requests.stages.sampling_reservation}</span>
                                      </div>
                                    ) : labtest.status === 7 || labtest.status === 9 ? (
                                      <div className='myaccordion_header_left'>
                                        <span style={{ color: "#444" }}>{messages.requests.stages.shipping}</span>
                                      </div>
                                    ) : labtest.status === 8 ? (
                                      <div className='myaccordion_header_left'>
                                        <span>{messages.requests.stages.not_sampling}</span>
                                      </div>
                                    ) : (
                                        <div className='myaccordion_header_left'>
                                            <span className={ labtest.is_approved ? 'accepted' : '' }>
                                              {labtest.is_approved ? messages.patients.labtests.accepted : messages.patients.labtests.rejected}</span>
                                            &nbsp;&nbsp;<b>|</b>&nbsp;&nbsp;
                                            <span className={labtest.payment_status === 3 ? 'paid' : '' }>
                                              {labtest.payment_status_name}</span>
                                        </div>
                                    )
                                  }
                                </>
                              )
                            }
                          </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div>
                          <div className="labtest-stages">
                              <div className="labtest-stage done">
                                  <img src={myImages.stage1_done} alt="stage" />
                                  <span>{messages.patients.labtests.stage1}</span>
                              </div>
                              <div className="labtest-stage done">
                                  <img src={myImages.stage2_done} alt="stage" />
                                  <span>{messages.patients.labtests.stage2}</span>
                              </div>
                              <div className="labtest-stage done">
                                  <img src={myImages.stage3_done} alt="stage" />
                                  <span>{messages.patients.labtests.stage3}</span>
                              </div>
                              <div className="labtest-stage done">
                                  <img src={myImages.stage4_done} alt="stage" />
                                  <span>{messages.patients.labtests.stage4}</span>
                              </div>
                              <div className="labtest-stage done">
                                  <img src={myImages.stage5_done} alt="stage" />
                                  <span>{messages.patients.labtests.stage5}</span>
                              </div>
                              <div className="labtest-stage">
                                  {
                                    labtest.request_stage === 4
                                    ? labtest.status === 2 
                                      ? <img src={myImages.stage6_canceled} alt="stage" />
                                      :  labtest.status > 2
                                      ? <img src={myImages.stage6_done} alt="stage" />
                                      : <img src={myImages.stage6} alt="stage" />
                                    : labtest.status === 2 
                                      ? <img src={myImages.stage6_progress} alt="stage" />
                                      : labtest.status > 2
                                      ? <img src={myImages.stage6_done} alt="stage" />
                                      : <img src={myImages.stage6} alt="stage" />
                                  }
                                  <span>{messages.patients.labtests.stage6}</span>
                              </div>
                              <div className="labtest-stage" 
                                  style={{ cursor: labtest.status > 2 ? 'pointer' : 'default' }}
                                  onClick={() => labtest.status === 3 ? setStageView(null) : labtest.status > 2 ? setStageView(`Payment${labtest.id}`) : setStageView(null)}>
                                  {
                                    labtest.request_stage === 4 
                                    ? labtest.status === 3 
                                      ? <img src={myImages.stage7_canceled} alt="stage" />
                                      : labtest.status > 3
                                      ? <img src={myImages.stage7_done} alt="stage" />
                                      : <img src={myImages.stage7} alt="stage" />
                                    : labtest.status === 11
                                      ? <img src={myImages.stage7_canceled} alt="stage" />
                                      : labtest.status === 3 
                                      ? <img src={myImages.stage7_progress} alt="stage" />
                                      : labtest.status > 3 
                                      ? <img src={myImages.stage7_done} alt="stage" />
                                      : <img src={myImages.stage7} alt="stage" />
                                  }
                                  <span>{messages.patients.labtests.stage7}</span>
                              </div>
                              <div className="labtest-stage" 
                                  style={{ cursor: labtest.status > 6 && labtest.payment_status !== 6 ? 'pointer' : 'default' }}
                                  onClick={() => labtest.status === 6 ? setStageView(null) : labtest.status > 6 && labtest.payment_status !== 6 ? setStageView(`Sampling${labtest.id}`) : setStageView(null)}>
                                  {
                                    labtest.status === 8
                                      ? <img src={myImages.stage8_canceled} alt="stage" />
                                      : labtest.status === 6 || labtest.status === 4
                                        ? <img src={myImages.stage8_progress} alt="stage" />
                                        : labtest.status > 6 && labtest.status !== 8 && labtest.status !== 11
                                        ? <img src={myImages.stage8_done} alt="stage" />
                                        : <img src={myImages.stage8} alt="stage" />
                                  }
                                  <span>{messages.patients.labtests.stage8}</span>
                              </div>
                              <div className="labtest-stage" 
                                  style={{ cursor: labtest.status >= 7 && labtest.status !== 8 && labtest.payment_status !== 6 ? 'pointer' : 'default' }}
                                  onClick={() => labtest.status === 7 ? setStageView(null) : labtest.status > 8  && labtest.payment_status !== 6 ? setStageView(`Shipping${labtest.id}`) : setStageView(null)}>
                                  {
                                    labtest.status === 7
                                      ? <img src={myImages.stage11_progress} alt="stage" />
                                      : labtest.status > 7 && labtest.status !== 8 && labtest.status !== 11
                                      ? <img src={myImages.stage11_done} alt="stage" />
                                      : <img src={myImages.stage11} alt="stage" />
                                  }
                                  <span>{messages.patients.labtests.stage11}</span>
                              </div>
                              <div className="labtest-stage" >
                                  {
                                    labtest.status === 9
                                      ? <img src={myImages.stage9_progress} alt="stage" />
                                      : labtest.status > 9 && labtest.status !== 11
                                      ? <img src={myImages.stage9_done} alt="stage" />
                                      : <img src={myImages.stage9} alt="stage" />
                                  }
                                  <span>{messages.patients.labtests.stage9}</span>
                              </div>
                              <div className="labtest-stage">
                                  <img src={myImages.stage10} alt="stage" />
                                  <span>{messages.patients.labtests.stage10}</span>
                              </div>
                          </div>
                          { // Payment
                             stageView === `Payment${labtest.id}` || (!stageView?.includes(labtest.id) && (labtest.request_stage !== 4 && labtest.status === 3)) ? (
                              <div className="payment-form-container">
                                <label className='big_title'>{messages.payments.payment_operation}</label>
                                <div className='form-group'>
                                    <label className="checkbox-container">{messages.payments.bank_transfert}
                                        <input type="radio" name={`customerType${labtest.id}`}
                                                value={1}
                                                disabled={stageView === `Payment${labtest.id}` || labtest?.payment?.payment_method === 2}
                                                checked={formData[index]?.payment_method === 1 && formData[index]?.id === labtest.id}
                                                onChange={(e) => {
                                                    setFormData(form => (
                                                        form.map(item => {
                                                            if (item.id === labtest.id) {
                                                                return {
                                                                    ...item,
                                                                    payment_method: 1
                                                                }
                                                            }
                                                            return item;
                                                        }
                                                        )
                                                    ));
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="checkbox-container">{messages.payments.online_payment}
                                        <input type="radio" name={`customerType${labtest.id}`}
                                                value={2}
                                                disabled={stageView === `Payment${labtest.id}` || labtest?.payment?.payment_method === 2}
                                                checked={formData[index]?.payment_method === 2 && formData[index]?.id === labtest.id}
                                                onChange={(e) => {
                                                    setFormData(form => (
                                                        form.map(item => {
                                                            if (item.id === labtest.id) {
                                                                return {
                                                                    ...item,
                                                                    payment_method: 2
                                                                }
                                                            }
                                                            return item;
                                                        }
                                                        )
                                                    ));
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="checkbox-container">{messages.payments.payment_done}
                                        <input type="radio" name={`customerType${labtest.id}`}
                                                value={3}
                                                disabled={stageView === `Payment${labtest.id}` || labtest?.payment?.payment_method === 2}
                                                checked={formData[index]?.payment_method === 3 && formData[index]?.id === labtest.id}
                                                onChange={(e) => {
                                                    setFormData(form => (
                                                        form.map(item => {
                                                            if (item.id === labtest.id) {
                                                                return {
                                                                    ...item,
                                                                    payment_method: 3
                                                                }
                                                            }
                                                            return item;
                                                        }
                                                        )
                                                    ));
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                                { formData[index]?.payment_method === 1 && formData[index]?.id === labtest.id && (
                                  <div className='bank_transfert_container'>
                                    {
                                      formData[index]?.bank_transfer_image && formData[index]?.id === labtest.id ? (
                                        <div className='bank_transfert_image_container'>
                                          <img src={formData[index]?.bank_transfer_image} alt="bank_transfer_image" />
                                          <span>{moment().format('DD MMMM YYYY')}</span>
                                          <DeleteForeverIcon onClick={() => cancelChangeImage(index)} />
                                        </div>
                                      ) : (
                                        <div className='bank_transfert_input_container'>
                                          <label className='required'>{messages.payments.bank_transfer_receipt}</label>
                                          <div className='image_inputs'>
                                            <input type="file" name={`bank_transfer_image${labtest?.id}`} id={`bank_transfer_image${labtest?.id}`}
                                                  onChange={(e) => onFileChange(e, index) } />
                                            <input type="text" placeholder={messages.payments.bank_transfer_placeholder}
                                                    readOnly={true} onClick={() => document.getElementById(`bank_transfer_image${labtest?.id}`).click()} />
                                            <AttachmentIcon style={{ pointerEvents: "none" }} />
                                          </div>
                                          
                                        </div>

                                      )

                                    }
                                  </div>
                                )}
                                { formData[index]?.payment_method === 3 && formData[index]?.id === labtest.id && (
                                  <div className='bank_transfert_container'>
                                    <div className='payment_rejection_reason'>
                            <label htmlFor="reason" className='required'>{messages.payments.new_offline_payment}</label>
                            {
                                formData[index]?.offline_payment === "new" ? (
                                    <div className='new_reason_input payment'>
                                        <input type='text' id='newReason' name='newReason' 
                                            placeholder={messages.payments.new_offline_payment}
                                            value={formData[index]?.new_offline_payment}
                                            onChange={(e) => {
                                                setFormData(form => (
                                                    form.map(item => {
                                                        if (item.id === labtest.id) {
                                                            return {
                                                                ...item,
                                                                new_offline_payment: e.target.value
                                                            }
                                                        }
                                                        return item;
                                                    }
                                                    )
                                                ));
                                            }}
                                            onKeyDown={e => {
                                                if (e.key === "Enter") {
                                                setPaymentMethodsList([ ...paymentMethodsList, { id: formData[index]?.new_offline_payment, name: formData[index]?.new_offline_payment } ]);
                                                setFormData(form => (
                                                    form.map(item => {
                                                        if (item.id === labtest.id) {
                                                            return {
                                                                ...item,
                                                                offline_payment: formData[index]?.new_offline_payment,
                                                            }
                                                        }
                                                        return item;
                                                    }
                                                )
                                              ))
                                            }}} 
                                        />
                                        <CheckIcon onClick={() => {
                                            setPaymentMethodsList([ ...paymentMethodsList, { id: formData[index]?.new_offline_payment, name: formData[index]?.new_offline_payment } ]);
                                            setFormData(form => (
                                                form.map(item => {
                                                    if (item.id === labtest.id) {
                                                        return {
                                                            ...item,
                                                            offline_payment: formData[index]?.new_offline_payment,
                                                        }
                                                    }
                                                    return item;
                                                }
                                            )
                                          ))
                                        }}/>
                                        <CloseIcon onClick={() => {
                                            setFormData(form => (
                                                form.map(item => {
                                                    if (item.id === labtest.id) {
                                                        return {
                                                            ...item,
                                                            offline_payment: 0,
                                                        }
                                                    }
                                                    return item;
                                                }
                                                ))
                                            )
                                        }} />
                                    </div>
                                ) : (
                                    <select name="nextStep" id="nextStep"
                                        value={formData[index].offline_payment}
                                        onChange={e => {
                                            document.getElementById('nextStep').style.borderColor = '#eee';
                                            setFormData(
                                                form => (
                                                    form.map(item => {
                                                        if (item.id === labtest.id) {
                                                            if (e.target.value === "new") {
                                                              return {
                                                                ...item,
                                                                offline_payment: e.target.value,
                                                              }
                                                            } else {
                                                              return {
                                                                ...item,
                                                                offline_payment: e.target.value,
                                                              }
                                                            }
                                                        }
                                                        return item;
                                                    }
                                                ))
                                              )
                                            }} 
                                        >
                                        <option value={0}>{messages.appointments.next_step_placeholder}</option>
                                        {paymentMethodsList?.map(step => <option key={step.id} value={step.id}>{step.name}</option>)}
                                        {!paymentMethodsList.find(pm => pm.id === 'new') && <option value={'new'} style={{ color: '#24d7d3' }} >{messages.payments.add_offline_payment}</option>}
                                    </select>
                                )
                              } 
                              </div>
                                {
                                  formData[index]?.bank_transfer_image && formData[index]?.id === labtest.id ? (
                                    <div className='bank_transfert_image_container'>
                                      <img src={formData[index]?.bank_transfer_image} alt="bank_transfer_image" />
                                      <span>{moment().format('DD MMMM YYYY')}</span>
                                      <DeleteForeverIcon onClick={() => cancelChangeImage(index)} />
                                    </div>
                                  ) : (
                                    <div className='bank_transfert_input_container'>
                                      <label className='required'>{messages.payments.bank_transfer_receipt}</label>
                                      <div className='image_inputs' onClick={() => document.getElementById(`bank_transfer_image${labtest?.id}`).click()}>
                                        <input type="file" name={`bank_transfer_image${labtest?.id}`} id={`bank_transfer_image${labtest?.id}`}
                                              onChange={(e) => onFileChange(e, index) } />
                                        <input type="text" placeholder={messages.payments.bank_transfer_placeholder}
                                                readOnly={true} />
                                        <AttachmentIcon />
                                      </div>
                                    </div>
                                  )
                                }
                                </div>
                                )}
                                { formData[index]?.payment_method === 2 && formData[index]?.id === labtest.id && (
                                  <div className='online_payments_container'>
                                    {
                                      formData[index]?.paymentable && formData[index]?.id === labtest.id ? (
                                        <div className='online_payments_content'>
                                          <p style={{ fontSize: "17px", color: "#6a2a53" }}>{messages.payments.online_payment_data}</p>
                                          <div className='online_payments_data'>
                                            <div className='online_payments_img'>
                                              <img src={myImages.visalogo} alt="visa" />
                                            </div>
                                            <div className='online_payments_infos'>
                                              <p>....{formData[index]?.paymentable?.last_digits}</p>
                                              <p><span>{messages.payments.finish}</span>&nbsp;<span>{formData[index]?.paymentable?.expiry_month}</span>/<span>{formData[index]?.paymentable?.expiry_year}</span></p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className='online_payments_input_container'></div>
                                      )

                                    }
                                  </div>
                                )}
                                <>
                                  <div className='payments_actions'>
                                    <button className='cancel' type='button' disabled={!formData[index]?.payment_method}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        cancelChangeImage(index);
                                        setFormData(form => (
                                          form.map(item => {
                                            if (item.id === labtest.id) {
                                              return {
                                                ...item,
                                                payment_method: null
                                              }
                                            }
                                            return item;
                                          }
                                          )
                                        ));
                                      }
                                    }>{messages.common.cancel}</button>
                                    <button type='button' disabled={!formData[index]?.payment_method || stageView?.includes(formData[index]?.id)}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleUpdateImg(labtest.id, labtest.payment?.id);
                                            }
                                    }>{messages.common.save}</button>
                                  </div>
                                  { imageErrors.sizeErr ? (
                                      <div className='error'>{imageErrors.msg}</div>
                                  ) : null }
                                </>
                            </div>
                            ) : null
                          }
                          { // Sampling
                                      
                            stageView === `Sampling${labtest.id}` || (!stageView?.includes(labtest.id) && (labtest.status === 4 || labtest.status === 6)) ? (
                              <div className="sampling-form-container">
                                <div className='form-group'>
                                    <label className="checkbox-container sampling_title">{messages.sampling.set_sampling_date}
                                        <input type="radio" name={`sampling${labtest.id}`}
                                                disabled={sampleReserved}
                                                value={2}
                                                checked={parseInt(formData[index]?.sampling_status) === 2 && formData[index]?.id === labtest.id}
                                                onChange={(e) => {
                                                    setFormData(form => (
                                                        form.map(item => {
                                                            if (item.id === labtest.id) {
                                                                return {
                                                                    ...item,
                                                                    sampling_status: 2  
                                                                }
                                                            }
                                                            return item;
                                                        }
                                                        )
                                                    ));
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                                {
                                  (formData[index]?.sampling_status === 2 && formData[index]?.id === labtest.id) ? (
                                    <div className='sampling_container'>
                                        <label className='sampling_label'>{messages.sampling.visit_lab}</label>
                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <label>{messages.sampling.sampling_city}</label>
                                            <select name="city_id" id="city_id"
                                                  value={formData[index].city_id}
                                                  disabled={sampleReserved}
                                                  onChange={e => {
                                                      document.getElementById('city_id').style.borderColor = '#eee';
                                                      setFormData(
                                                          form => (
                                                              form.map(item => {
                                                                  if (item.id === labtest.id) {
                                                                      return {
                                                                        ...item,
                                                                        city_id: e.target.value,
                                                                        agenciesList: agenciesList?.filter(agency => parseInt(agency.city_id) === parseInt(e.target.value))
                                                                      }
                                                                  }
                                                                  return item;
                                                              }
                                                          ))
                                                        )
                                                      }} 
                                                  >
                                                  <option value={0}>{messages.sampling.sampling_city_placeholder}</option>
                                                  {cities?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}
                                              </select>
                                          </div>
                                          <div className='col-md-4 working_hours_container'>
                                            <label>{messages.sampling.nearest_sampling_point}</label>
                                            <select name="agency_id" id="agency_id"
                                                  value={formData[index].agency_id}
                                                  disabled={sampleReserved}
                                                  onChange={e => {
                                                      document.getElementById('agency_id').style.borderColor = '#eee';
                                                      setSelectedAgency(e.target.value);
                                                      setFormData(
                                                          form => (
                                                              form.map(item => {
                                                                  if (item.id === labtest.id) {
                                                                      return {
                                                                        ...item,
                                                                        agency_id: e.target.value,
                                                                      }
                                                                  }
                                                                  return item;
                                                              }
                                                          ))
                                                        )
                                                      }}
                                                  >
                                                  <option value={0}>{messages.sampling.nearest_sampling_point_placeholder}</option>
                                                  {formData.find(item => item.id === labtest.id)?.agenciesList?.map(agency => <option key={agency.id} value={agency.id}>{agency.name}</option>)}
                                              </select>
                                              <div onClick={() => setWorkingHoursModal(true)} 
                                                  className={`${formData[index].agency_id > 0 ? 'working_hours show' : 'working_hours'}`}>
                                                <ErrorIcon /> {messages.sampling.labSchudle}
                                              </div>
                                          </div>
                                        </div>
                                        <label className='sampling_label'>{messages.sampling.sampling_date_title}</label>
                                        <div className='row'>
                                          <div className='col-md-4'>
                                            <label>{messages.sampling.sampling_date}</label>
                                            <div className="date-input-container">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        clearable
                                                        id="mydate-picker"
                                                        inputProps={{ 'placeholder': `${messages.sampling.sampling_date_placeholder}` }}
                                                        value={formData[index]?.sampling_date}
                                                        disabled={sampleReserved}
                                                        onChange={date => date ? setFormData(
                                                            form => (
                                                                form.map(item => {
                                                                    if (item.id === labtest.id) {
                                                                        return {
                                                                            ...item,
                                                                            sampling_date: moment(date).format('YYYY-MM-DD'),
                                                                        }
                                                                    }
                                                                    return item;
                                                                }
                                                            ))
                                                        ) : setFormData(
                                                            form => (
                                                                form.map(item => {
                                                                    if (item.id === labtest.id) {
                                                                        return {
                                                                            ...item,
                                                                            sampling_date: null,
                                                                        }
                                                                    }
                                                                    return item;
                                                                }
                                                            ))
                                                        )}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                          </div>
                                          <div className='col-md-3'>
                                              <label>{messages.sampling.sampling_time}</label>
                                              <input  step={900} type="time" placeholder='1 PM' 
                                                      value={formData[index]?.sampling_time}
                                                      disabled={sampleReserved}
                                                      onChange={e => 
                                                          setFormData(
                                                              form => (
                                                                  form.map(item => {
                                                                      if (item.id === labtest.id) {
                                                                          return {
                                                                              ...item,
                                                                              sampling_time: e.target.value,
                                                                          }
                                                                      }
                                                                      return item;
                                                                  }
                                                              ))
                                                          )
                                                      }
                                                      style={{width: '100%'}}
                                              />
                                          </div> 
                                        </div>
                                        {formData[index]?.notes && <>
                                          <label className='sampling_label'>{messages.sampling.notes}</label>
                                          <p>{formData[index]?.notes}</p>
                                        </>}
                                    </div>
                                  ) : null
                                }
                                <div className='form-group'>
                                    <label className="checkbox-container sampling_title">{messages.sampling.sampling_done}
                                        <input type="radio" name={`sampling${labtest.id}`}
                                                disabled={sampleReserved}
                                                value={3}
                                                checked={parseInt(formData[index]?.sampling_status) === 3 && formData[index]?.id === labtest.id}
                                                onChange={(e) => {
                                                    setFormData(form => (
                                                        form.map(item => {
                                                            if (item.id === labtest.id) {
                                                                return {
                                                                    ...item,
                                                                    sampling_status: 3
                                                                }
                                                            }
                                                            return item;
                                                        }
                                                        )
                                                    ));
                                                }} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                                  <div className='payments_actions'>
                                    <button className='cancel' type='button' disabled={!formData[index]?.sampling_status || stageView?.includes(formData[index]?.id)}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              cancelChangeImage(index);
                                              setFormData(form => (
                                                form.map(item => {
                                                  if (item.id === labtest.id) {
                                                    return {
                                                      ...item,
                                                      id: null, 
                                                      agency_id: 0, 
                                                      date: `${moment().format("YYYY-MM-DD")} 00:00`,
                                                      patientId: patientId,
                                                    }
                                                  }
                                                  return item;
                                                }
                                                )
                                              ));
                                            }
                                    }>{messages.common.cancel}</button>
                                    <button type='button' disabled={!formData[index]?.sampling_status || stageView?.includes(formData[index]?.id)}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (sampleReserved) {
                                                dispatch(setSampleReserved(false));
                                              } else if (labtest.samplingReservation && labtest.samplingReservation?.id) {
                                                  dispatch(updateSamplingReservationRequest({
                                                    id: labtest.samplingReservation?.id, 
                                                    agency_id: formData[index]?.agency_id, 
                                                    date: `${moment(formData[index]?.sampling_date).format("YYYY-MM-DD")} ${formData[index]?.sampling_time}:00`,
                                                    labtestID: labtest.id,
                                                    patientId: patientId,
                                                  }));
                                              } else if (formData[index]?.sampling_status === 2) {
                                                  dispatch(samplingReservationRequest({
                                                    agency_id: formData[index]?.agency_id, 
                                                    date: `${moment(formData[index]?.sampling_date).format("YYYY-MM-DD")} ${formData[index]?.sampling_time}:00`,
                                                    labtestID: labtest.id,
                                                    patientId: patientId,
                                                  }));
                                                  setTimeout(() => {
                                                    dispatch(getPatientLabtestsListRequest(patientId));
                                                  }, 1000);
                                              } else {
                                                dispatch(samplingForceDepositedRequest({
                                                  id: labtest?.id,
                                                }))
                                              }
                                            }
                                    }>{sampleReserved || labtest.samplingReservation ? messages.common.edit : messages.common.save}</button>
                                  </div>
                                  { imageErrors.sizeErr ? (
                                      <div className='error'>{imageErrors.msg}</div>
                                  ) : null }
                            </div>
                            ) : null
                          }
                          
                          { // Shipping
                                      
                            stageView === `Shipping${labtest.id}` || (!stageView?.includes(labtest.id) && labtest.status === 7) ? (
                              <div className="sampling-form-container">
                                <label className='shipping_label'>{messages.shipping.shipping_details}</label>
                                {
                                  formData[index]?.shipments?.map((shipment, shippIndex) => (
                                    <div key={`shipment${shippIndex}`} className='shipping_row'>
                                        {formData[index]?.shipments?.length > 1 && shippIndex === 0 && <label className='shipping_journey'>{messages.shipping.first_journey}</label>}
                                        {formData[index]?.shipments?.length > 1 && shippIndex === 1 && <label className='shipping_journey'>{messages.shipping.second_journey}</label>}
                                        <div className='row' >
                                            <div className="col-md-3">
                                              <label htmlFor={`lab_test_shipping_locations${index}_from`} className='required'>{messages.shared.from}</label>
                                              {
                                                isNewLocation?.id === labtest?.id && isNewLocation?.type === "pickup" && isNewLocation.index === shippIndex ? (
                                                  <div className='new_reason_input payment'>
                                                      <input type='text' id={`newLocationPick${shippIndex}`} name={`newLocationPick${shippIndex}`} 
                                                          placeholder={messages.shared.from}
                                                          value={formData[index]?.shipments[shippIndex]?.pickup_location}
                                                          onChange={(e) => {
                                                              setFormData(form => (
                                                                  form.map(item => {
                                                                      if (item.id === labtest.id) {
                                                                          return {
                                                                              ...item,
                                                                              shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                                  if (oldShipIndex === shippIndex) {
                                                                                      return {
                                                                                          ...oldShip,
                                                                                          pickup_location: e.target.value,
                                                                                      }
                                                                                  }
                                                                                  return oldShip;
                                                                              })
                                                                          }
                                                                      }
                                                                      return item;
                                                                  }
                                                                  )
                                                              ));
                                                          }}
                                                          onKeyDown={e => {
                                                              if (e.key === "Enter") {
                                                              setFormData(form => (
                                                                  form.map(item => {
                                                                      if (item.id === labtest.id) {
                                                                          return {
                                                                              ...item,
                                                                              shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                                  if (oldShipIndex === shippIndex) {
                                                                                      return {
                                                                                          ...oldShip,
                                                                                          pickup_location_id: null,
                                                                                      }
                                                                                  }
                                                                                  return oldShip;
                                                                              })
                                                                          }
                                                                      }
                                                                      return item;
                                                                  }
                                                              )
                                                            ))
                                                            setIsNewLocation(null);
                                                          }}} 
                                                      />
                                                      <CheckIcon onClick={() => {
                                                          setFormData(form => (
                                                            form.map(item => {
                                                                if (item.id === labtest.id) {
                                                                    return {
                                                                        ...item,
                                                                        shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                            if (oldShipIndex === shippIndex) {
                                                                                return {
                                                                                    ...oldShip,
                                                                                    pickup_location_id: null,
                                                                                }
                                                                            }
                                                                            return oldShip;
                                                                        })
                                                                    }
                                                                }
                                                                return item;
                                                            }
                                                        )
                                                      ))
                                                      setIsNewLocation(null);
                                                      }}/>
                                                      <CloseIcon onClick={() => {
                                                          setFormData(form => (
                                                            form.map(item => {
                                                                if (item.id === labtest.id) {
                                                                    return {
                                                                        ...item,
                                                                        shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                            if (oldShipIndex === shippIndex) {
                                                                                return {
                                                                                    ...oldShip,
                                                                                    pickup_location: null,
                                                                                    pickup_location_id: 0,
                                                                                }
                                                                            }
                                                                            return oldShip;
                                                                        })
                                                                    }
                                                                }
                                                                return item;
                                                            }
                                                        )
                                                      ))
                                                      setIsNewLocation(null);
                                                      }} />
                                                  </div>
                                              ) : (
                                                <select name={`lab_test_shipping_locations${index}_from${shippIndex}`} id={`lab_test_shipping_locations${index}_from${shippIndex}`}
                                                      value={formData[index].shipments[shippIndex].pickup_location_id}
                                                      onChange={e => {
                                                          setFormData(
                                                              form => (
                                                                  form.map(item => {
                                                                      if (item.id === labtest.id) {
                                                                          return {
                                                                              ...item,
                                                                              shipments: item.shipments.map((ship, shipI) => {
                                                                                  if (shipI === shippIndex) {
                                                                                      if (e.target.value === 'new') {
                                                                                          setIsNewLocation({ id: labtest.id, type: 'pickup', index: shippIndex });
                                                                                          return {
                                                                                              ...ship,
                                                                                              pickup_location: "",
                                                                                          }
                                                                                      } else {
                                                                                        return {
                                                                                          ...ship,
                                                                                          pickup_location_id: parseInt(e.target.value),
                                                                                      }
                                                                                      }
                                                                                  }
                                                                                  return ship;
                                                                              })
                                                                          }
                                                                      }
                                                                      return item;
                                                                  }
                                                              ))
                                                          )
                                                      }}
                                                      >
                                                  {formData[index]?.shipments[shippIndex]?.pickup_location ? (
                                                      <option value={null} selected>{formData[index]?.shipments[shippIndex]?.pickup_location}</option>
                                                  ) : (
                                                    <option value={0}>{messages.shipping.shipping_destination_from_placeholder}</option>
                                                  )}
                                                  <option value={"new"} 
                                                          style={{ color: "#2eaaa8", fontWeight: "bold" }}
                                                          >{messages.shipping.add_new_destination} +</option>
                                                  {shippingLocations?.map(location => {
                                                    if (location.id === 1) {
                                                      if (labtest?.samplingReservation?.agency_name) {
                                                        return (<option key={location.id} value={location.id} 
                                                                        title={labtest?.samplingReservation?.agency_name} >
                                                            {labtest?.samplingReservation?.agency_name?.length > 25 ? `${labtest?.samplingReservation?.agency_name?.substr(0, 25)}..` : labtest?.samplingReservation?.agency_name}</option>)
                                                      } else {
                                                        return (<option key={location.id} value={location.id}>{location.location}</option>)
                                                      }
                                                    } else {
                                                      return (<option key={location.id} value={location.id}>{location.location}</option>)
                                                    }
                                                    
                                                  })}
                                              </select>
                                              )
                                            }
                                            </div>
                                              <div className="col-md-3">
                                                <label htmlFor={`lab_test_shipping_locations${index}_from`} className='required'>{messages.shared.to}</label>
                                                {
                                                isNewLocation?.id === labtest?.id && isNewLocation?.type === "delivery" && isNewLocation.index === shippIndex ? (
                                                  <div className='new_reason_input payment'>
                                                      <input type='text' id={`newLocationDelivery${shippIndex}`} name={`newLocationDelivery${shippIndex}`} 
                                                          placeholder={messages.shared.to}
                                                          value={formData[index]?.shipments[shippIndex]?.delivery_location}
                                                          onChange={(e) => {
                                                              setFormData(form => (
                                                                  form.map(item => {
                                                                      if (item.id === labtest.id) {
                                                                          return {
                                                                              ...item,
                                                                              shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                                  if (oldShipIndex === shippIndex) {
                                                                                      return {
                                                                                          ...oldShip,
                                                                                          delivery_location: e.target.value,
                                                                                      }
                                                                                  }
                                                                                  return oldShip;
                                                                              })
                                                                          }
                                                                      }
                                                                      return item;
                                                                  }
                                                                  )
                                                              ));
                                                          }}
                                                          onKeyDown={e => {
                                                              if (e.key === "Enter") {
                                                              setFormData(form => (
                                                                  form.map(item => {
                                                                      if (item.id === labtest.id) {
                                                                          return {
                                                                              ...item,
                                                                              shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                                  if (oldShipIndex === shippIndex) {
                                                                                      return {
                                                                                          ...oldShip,
                                                                                          delivery_location_id: null,
                                                                                      }
                                                                                  }
                                                                                  return oldShip;
                                                                              })
                                                                          }
                                                                      }
                                                                      return item;
                                                                  }
                                                              )
                                                            ))
                                                            setIsNewLocation(null);
                                                          }}} 
                                                      />
                                                      <CheckIcon onClick={() => {
                                                          setFormData(form => (
                                                            form.map(item => {
                                                                if (item.id === labtest.id) {
                                                                    return {
                                                                        ...item,
                                                                        shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                            if (oldShipIndex === shippIndex) {
                                                                                return {
                                                                                    ...oldShip,
                                                                                    delivery_location_id: null,
                                                                                }
                                                                            }
                                                                            return oldShip;
                                                                        })
                                                                    }
                                                                }
                                                                return item;
                                                            }
                                                        )
                                                      ))
                                                      setIsNewLocation(null);
                                                      }}/>
                                                      <CloseIcon onClick={() => {
                                                          setFormData(form => (
                                                            form.map(item => {
                                                                if (item.id === labtest.id) {
                                                                    return {
                                                                        ...item,
                                                                        shipments: item.shipments.map((oldShip, oldShipIndex) => {
                                                                            if (oldShipIndex === shippIndex) {
                                                                                return {
                                                                                    ...oldShip,
                                                                                    delivery_location: null,
                                                                                    delivery_location_id: 0,
                                                                                }
                                                                            }
                                                                            return oldShip;
                                                                        })
                                                                    }
                                                                }
                                                                return item;
                                                            }
                                                        )
                                                      ))
                                                      setIsNewLocation(null);
                                                      }} />
                                                  </div>
                                              ) : (
                                                <select name={`lab_test_shipping_locations${index}_from${shippIndex}`} id={`lab_test_shipping_locations${index}_from${shippIndex}`}
                                                      value={formData[index]?.shipments[shippIndex]?.delivery_location_id}
                                                      onChange={e => {
                                                          setFormData(
                                                              form => (
                                                                  form.map(item => {
                                                                      if (item.id === labtest.id) {
                                                                          return {
                                                                              ...item,
                                                                              shipments: item.shipments.map((ship, shipI) => {
                                                                                  if (shipI === shippIndex) {
                                                                                      if (e.target.value === 'new') {
                                                                                          setIsNewLocation({ id: labtest.id, type: 'delivery', index: shippIndex });
                                                                                          return {
                                                                                              ...ship,
                                                                                              delivery_location: "",
                                                                                          }
                                                                                      } else {
                                                                                        return {
                                                                                          ...ship,
                                                                                          delivery_location_id: parseInt(e.target.value),
                                                                                      }
                                                                                      }
                                                                                  }
                                                                                  return ship;
                                                                              })
                                                                          }
                                                                      }
                                                                      return item;
                                                                  }
                                                              ))
                                                          )
                                                      }}
                                                      >
                                                  {formData[index]?.shipments[shippIndex]?.delivery_location ? (
                                                      <option value={null} selected>{formData[index]?.shipments[shippIndex]?.delivery_location}</option>
                                                  ) : (
                                                    <option value={0}>{messages.shipping.shipping_destination_from_placeholder}</option>
                                                  )}
                                                  <option value={"new"} 
                                                          style={{ color: "#2eaaa8", fontWeight: "bold" }}
                                                          >{messages.shipping.add_new_destination} +</option>
                                                  {shippingLocations?.map(location => {
                                                    if (location.id === 1) {
                                                      if (labtest?.samplingReservation?.agency_name) {
                                                        return (<option key={location.id} value={location.id} 
                                                          title={labtest?.samplingReservation?.agency_name} >
                                                            {labtest?.samplingReservation?.agency_name?.length > 25 ? `${labtest?.samplingReservation?.agency_name?.substr(0, 25)}..` : labtest?.samplingReservation?.agency_name}</option>)
                                                      } else {
                                                        return (<option key={location.id} value={location.id}>{location.location}</option>)
                                                      }
                                                    } else {
                                                      return (<option key={location.id} value={location.id}>{location.location}</option>)
                                                    }
                                                  })}
                                              </select>
                                              )
                                            }
                                              </div>
                                              <div className="col-md-3">
                                                <label htmlFor="shipping_company" className='required'>{messages.labTests.form.shipping_company}</label>
                                                <select name="shipping_company" id="shipping_company"
                                                        value={shipment.shipping_company}
                                                        onChange={e => {
                                                            setFormData(
                                                                form => (
                                                                    form.map(item => {
                                                                        if (item.id === labtest.id) {
                                                                            return {
                                                                                ...item,
                                                                                shipments: item.shipments.map((ship, shipI) => {
                                                                                    if (shipI === shippIndex) {
                                                                                        return {
                                                                                            ...ship,
                                                                                            shipping_company: parseInt(e.target.value),
                                                                                        }
                                                                                    }
                                                                                    return ship;
                                                                                })
                                                                            }
                                                                        }
                                                                        return item;
                                                                    }
                                                                ))
                                                            )
                                                        }}
                                                        >
                                                    <option value={0}>{messages.labTests.form.shipping_company_placeholder}</option>
                                                    {shippingCompanies?.map(company => <option key={company.id} value={company.id}>{company.name}</option>)}
                                                </select>
                                              </div>
                                              <div className="col-md-3">
                                                  {shippIndex === 0 ? formData[index]?.shipments?.length === 1 && formData[index]?.shipments[shippIndex].delivery_location_id !== 3 && 
                                                                    <div className='shipping_location_add'
                                                                      style={{ cursor: formData[index]?.shipments?.length === 1 ? 'pointer' : 'not-allowed' }}
                                                                      onClick={() => {
                                                                          if (formData[index]?.shipments?.length < 2) {
                                                                              setFormData(
                                                                                  form => (
                                                                                      form.map(item => {
                                                                                          if (item.id === labtest.id) {
                                                                                              return {
                                                                                                  ...item,
                                                                                                  shipments: [...item.shipments, {
                                                                                                    id: null,
                                                                                                    pickup_location_id: 0,
                                                                                                    delivery_location_id: 0,
                                                                                                    pickup_location: '',
                                                                                                    delivery_location: '',
                                                                                                    shipping_company: 0,
                                                                                                    status: 0,
                                                                                                    notes: '',
                                                                                                  }]
                                                                                              }
                                                                                          }
                                                                                          return item;
                                                                                      }
                                                                                  ))
                                                                              )
                                                                          }
                                                                      }}>
                                                      <AddCircleOutlineIcon />
                                                  </div> :
                                                  <CancelOutlinedIcon className='shipping_location_remove' onClick={() => {
                                                      setFormData(
                                                          form => (
                                                              form.map(item => {
                                                                  if (item.id === labtest.id) {
                                                                      return {
                                                                          ...item,
                                                                          shipments: item.shipments.filter((ship, shipI) => shipI !== shippIndex)
                                                                      }
                                                                  }
                                                                  return item;
                                                              }
                                                          ))
                                                      )
                                                  }} />
                                                  }
                                              </div>
                                          </div>
                                          <div className="row">
                                            <div className='col-md-3 form-group'>
                                              <label className="checkbox-container sampling_title">{messages.shipping.shipping_done}
                                                <input type="radio" name={`shipping${labtest.id}-${shippIndex}`}
                                                        value={2}
                                                        checked={shipment.status === 2 && formData[index]?.id === labtest.id}
                                                        onChange={(e) => {
                                                            e.preventDefault();
                                                            setTimeout(() => {
                                                              setFormData(form => (
                                                                form.map(item => {
                                                                    if (item.id === labtest.id) {
                                                                        return {
                                                                            ...item,
                                                                            shipments: item.shipments?.map((ship, shipI) => {
                                                                                if (shipI === shippIndex) {
                                                                                    return {
                                                                                        ...ship,
                                                                                        status: 2,
                                                                                    }
                                                                                }
                                                                                return ship;
                                                                            }),
                                                                        }
                                                                    }
                                                                    return item;
                                                                }
                                                                )
                                                              ));
                                                            }, 100);
                                                        }} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className='col-md-3 form-group'>
                                            <label className="checkbox-container sampling_title">{messages.shipping.shipping_not_done}
                                                <input type="radio" name={`shipping${labtest.id}-${shippIndex}`}
                                                        value={3}
                                                        checked={shipment.status === 3 && formData[index]?.id === labtest.id}
                                                        onChange={(e) => {
                                                            e.preventDefault();
                                                            setTimeout(() => {
                                                              setFormData(form => (
                                                                form.map(item => {
                                                                    if (item.id === labtest.id) {
                                                                        return {
                                                                            ...item,
                                                                            shipments: item.shipments?.map((ship, shipI) => {
                                                                                if (shipI === shippIndex) {
                                                                                    return {
                                                                                        ...ship,
                                                                                        status: 3,
                                                                                    }
                                                                                }
                                                                                return ship;
                                                                            }),
                                                                        }

                                                                    }
                                                                    return item;
                                                                }
                                                                )
                                                              ));
                                                            }, 100);
                                                        }} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className='col-md-3'></div>
                                        <div className='col-md-3'></div>
                                      </div>
                                      <div className="row">
                                            <div className='col-md-6' style={{ padding: "0 15px" }}>
                                              <label style={{ display: "block" }}>{messages.payments.notes}</label>
                                              <textarea name={`shipping${labtest.id}-notes`}
                                                        value={shipment.notes}
                                                        onChange={(e) => {
                                                            e.preventDefault();
                                                            setFormData(form => (
                                                                form.map(item => {
                                                                    if (item.id === labtest.id) {
                                                                        return {
                                                                            ...item,
                                                                            shipments: item.shipments.map((ship, shipI) => {
                                                                                if (shipI === shippIndex) {
                                                                                    return {
                                                                                        ...ship,
                                                                                        notes: e.target.value,
                                                                                    }
                                                                                }
                                                                                return ship;
                                                                            })
                                                                        }
                                                                    }
                                                                    return item;
                                                              })
                                                            ));
                                                        }} />
                                        </div>
                                        <div className='col-md-6'></div>
                                      </div>   
                                    </div>
                                  ))
                                }
                                  <div className='payments_actions'>
                                    <button className='cancel' type='button' disabled={!formData[index]?.shipping}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              cancelChangeImage(index);
                                              setFormData(form => (
                                                form.map(item => {
                                                  if (item.id === labtest.id) {
                                                    return {
                                                      ...item,
                                                      shipments: null
                                                    }
                                                  }
                                                  return item;
                                                }
                                                )
                                              ));
                                            }
                                    }>{messages.common.cancel}</button>
                                    <button type='button' 
                                            disabled={!formData[index]?.shipments || stageView?.includes(formData[index]?.id)}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              const shipmentArray = formData[index]?.shipments?.map((ship, shipI) => {
                                                return {
                                                  id: ship.id,
                                                  pickup_location_id: ship.pickup_location_id,
                                                  pickup_location: ship.pickup_location,
                                                  delivery_location_id: ship.delivery_location_id,
                                                  delivery_location: ship.delivery_location,
                                                  status: ship.status,
                                                  shipping_company: ship.shipping_company,
                                                  notes: ship.notes,
                                                }
                                              });
                                              dispatch(changeShipmentsStatusRequest({
                                                  labtestId: labtest.id,
                                                  shipments: shipmentArray,
                                              }))
                                              setTimeout(() => {
                                                dispatch(getPatientLabtestsListRequest(patientId));
                                              }, 1000);
                                            }
                                    }>{messages.common.save}</button>
                                  </div>
                                  { imageErrors.sizeErr ? (
                                      <div className='error'>{imageErrors.msg}</div>
                                  ) : null }
                            </div>
                            ) : null
                          }
                        </div>
                      </AccordionDetails>
                  </StyledAccordion>
                  <div className='divider'>&nbsp;</div>
                </>
              ))
            }
            <WorkingHours show={workingHoursModal} close={() => setWorkingHoursModal(false)} schedules={agenciesList?.find(ag => ag.id === parseInt(selectedAgency))?.schedules} />
        </div>
      )
    } else {
      return (
        <div className="no-data-block">
            {messages.patients.labtests.empty}
        </div>
      )
    }
}

export default injectIntl(PatientLabtests)